"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAccessory = void 0;
var _react = require("react");
var _upsellUtils = require("../../utils/upsellUtils");
var _productCatalogActions = require("../../store/productCatalog/productCatalogActions");
var _upsellActions = require("../../store/upsell/upsellActions");
var _upsellSelectors = require("../../store/upsell/upsellSelectors");
var _useUpsell = _interopRequireDefault(require("./useUpsell"));
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useAccessory = () => {
  const displayedProduct = (0, _useAppSelector.useAppSelector)(_upsellSelectors.selectDisplayedUpsellProductDetails);
  const plans = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectRecommendationPlans);
  const slidersValues = (0, _useAppSelector.useAppSelector)(_upsellSelectors.selectSlidersValues);
  const {
    onUpsellProductAdd
  } = (0, _useUpsell.default)();
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const currentVariant = displayedProduct.selectedVariant;
  const {
    variants,
    selectionTree
  } = displayedProduct.variants;
  const [paymentInfo, setPaymentInfo] = (0, _react.useState)({});
  const {
    defaultUpfront
  } = displayedProduct;
  const handleVariantChange = (color, size) => {
    const variant = variants.find(v => v.color.includes(color) && v.size.includes(size));
    dispatch((0, _upsellActions.updateSelectedUpsellVariant)(variant, displayedProduct.id));
    resetSlidersValues();
  };
  const handleSliderValuesChange = sliderValues => {
    const {
      totalPriceValue,
      upFrontValue,
      recurringValue
    } = sliderValues;
    const totalPayment = (0, _upsellUtils.calculateUpsellPayment)(totalPriceValue, upFrontValue, recurringValue);
    setPaymentInfo({
      ...totalPayment,
      monthlyUnit: currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.priceOffering.maxTerm.unitOfMeasure
    });
  };
  const handleAddToCart = () => {
    displayedProduct.paymentOptions = (0, _upsellUtils.createPaymentOptions)(paymentInfo.monthlyPrice, paymentInfo.monthlyPeriod, '', paymentInfo.upfront);
    dispatch((0, _productCatalogActions.setProductRelationshipOfferingSelectedPrice)(displayedProduct.id, paymentInfo));
    onUpsellProductAdd(displayedProduct);
    dispatch((0, _upsellActions.goBackToRecommendation)());
  };
  const resetSlidersValues = () => {
    dispatch((0, _upsellActions.clearSlidersValues)());
  };
  const currentVariantCharacteristicValueByName = characteristicName => {
    var _currentVariant$produ, _currentVariant$produ2;
    const currentVariantCharacteristicByName = (_currentVariant$produ = currentVariant.productSpecification) === null || _currentVariant$produ === void 0 ? void 0 : (_currentVariant$produ2 = _currentVariant$produ.productSpecCharacteristic) === null || _currentVariant$produ2 === void 0 ? void 0 : _currentVariant$produ2.find(characteristic => characteristic.name === characteristicName);
    return currentVariantCharacteristicByName === null || currentVariantCharacteristicByName === void 0 ? void 0 : currentVariantCharacteristicByName.productSpecCharacteristicValue[0].value;
  };
  return {
    selectionTree,
    currentVariant,
    paymentInfo,
    defaultUpfront,
    plans,
    handleVariantChange,
    handleSliderValuesChange,
    handleAddToCart,
    slidersValues,
    resetSlidersValues,
    currentVariantCharacteristicValueByName
  };
};
exports.useAccessory = useAccessory;